import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, TemplateRef, ViewChild } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextModule, I18NextPipe } from 'angular-i18next';
import { Alert, AlertModule, AlertService, ButtonModule, MbsPopupType, MbsSize, ModalService } from 'mbs-ui-kit';
import { TwoFactorEnableModalComponent } from 'mbs-ui-shared@components';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { TFAFacade } from 'mbs-ui-shared@facades/tfa.facade';
import { AppPersistentStateService } from 'mbs-ui-shared@services';
import moment from 'moment';
import { noop } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'mbs-force-tfa-alert',
  templateUrl: './force-tfa-alert.component.html',
  standalone: true,
  imports: [CommonModule, AlertModule, ButtonModule, I18NextModule]
})
export class ForceTfaAlertComponent implements AfterViewInit {
  @ViewChild('forceTfaAlert', { static: true }) forceTfaAlert: TemplateRef<any>;

  public leftDays: number;

  protected readonly alertId = 'force-tfa-alert';

  constructor(
    private i18n: I18NextPipe,
    private authFacade: AuthFacade,
    private TFAFacade: TFAFacade,
    private modalService: ModalService,
    private alertService: AlertService,
    private appStorage: AppPersistentStateService
  ) {}

  ngAfterViewInit() {
    this.TFAFacade.loadTFAStatus();

    if (this.appStorage.data.showNotificationForcedTFA) {
      this.TFAFacade.TFAStatus.subscribe((TFAStatus) => {
        this.handleForceTFA(TFAStatus);
      });
    }
  }

  public openTFAModal(): void {
    this.modalService
      .openCustom(TwoFactorEnableModalComponent, {
        data: {
          title: this.i18n.transform('shared:tfa.enableTwoFactorAuth')
        },
        size: MbsSize.md
      })
      .catch(noop);
  }

  private handleForceTFA(TFAStatus: boolean) {
    this.alertService.clearById(this.alertId);

    const forceTFADate = this.authFacade.currentUserValue?.ForcedTwoFactorAuthDate;

    const diff = moment.utc(forceTFADate).diff(new Date());
    const days = moment.utc(forceTFADate).diff(new Date(), 'days');

    if (TFAStatus || !forceTFADate || diff < 0) {
      return;
    }

    this.leftDays = Math.max(1, days + 1);

    const alert = new Alert({
      id: this.alertId,
      icon: true,
      content: this.forceTfaAlert,
      ignoreRouteChanges: true,
      overlay: false,
      type: MbsPopupType.info
    });

    this.alertService.alert(alert).subscribe(() => (this.appStorage.data.showNotificationForcedTFA = false));
  }
}
